export default "__VITE_ASSET__ef15a5b7__"